var _rect, _path, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersistence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 25.9930276,
    height: 25.9919977,
    rx: 1.49653
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8530004,13.7983084 C19.8530004,14.840769 19.6137556,15.7977483 19.135266,16.6692462 C18.6567763,17.5237508 17.9219456,18.2158408 16.9307738,18.7456193 C15.939602,19.2753977 14.7091854,19.540287 13.2395239,19.540287 L10.5223496,19.540287 L10.5223496,26 L6.13898905,26 L6.13898905,8.00508214 L13.2395239,8.00508214 C14.6749928,8.00508214 15.8883132,8.25287509 16.879485,8.748461 C17.8706568,9.2440469 18.6140357,9.92765061 19.1096216,10.7991485 C19.6052075,11.6707494 19.8530004,12.6704694 19.8530004,13.7983084 Z M12.9062496,16.0540893 C13.743658,16.0540893 14.3674659,15.8575852 14.7775705,15.4644739 C15.187675,15.0714657 15.3927273,14.5160428 15.3927273,13.7983084 C15.3927273,13.0805739 15.187675,12.525151 14.7775705,12.1321428 C14.3674659,11.7390315 13.743658,11.5425274 12.9062496,11.5425274 L10.5223496,11.5425274 L10.5223496,16.0540893 L12.9062496,16.0540893 Z",
    id: "\\u5F62\\u72B6",
    fill: "#000000"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E50913",
    points: "19.8532064 3.44622735 6.13914353 3.44622735 6.13914353 6.34223282 19.8532064 6.34223282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistence);
export default __webpack_public_path__ + "static/media/persistence.f270d97a6e7eef6244d458678f9eb1c8.svg";
export { ForwardRef as ReactComponent };